import { render, staticRenderFns } from "./TableBubbleMeasurments.vue?vue&type=template&id=c7b2e438&scoped=true"
import script from "./TableBubbleMeasurments.vue?vue&type=script&lang=js"
export * from "./TableBubbleMeasurments.vue?vue&type=script&lang=js"
import style0 from "./TableBubbleMeasurments.vue?vue&type=style&index=0&id=c7b2e438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b2e438",
  null
  
)

export default component.exports